import { Reveal } from "@/components/site/Reveal";
import {
  ResourceCard,
  type EditorialResource,
} from "@/components/resources/ResourceEditorialPrimitives";
import { formatUpdated } from "@/lib/article-utils";

export type RelatedItem = EditorialResource & {
  title_en: string;
  title_es: string;
  excerpt_en: string;
  excerpt_es: string;
  tags_en: string[];
  tags_es: string[];
  reading_minutes: number;
};

interface RelatedResourcesProps {
  items: RelatedItem[];
  locale: "en" | "es";
}

export function RelatedResources({ items, locale }: RelatedResourcesProps) {
  if (!items || items.length === 0) return null;

  const isEs = locale === "es";

  return (
    <section className="mt-20 border-t border-border pt-14">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-muted-foreground">
          {isEs ? "Sigue leyendo" : "Keep reading"}
        </p>
        <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
          {isEs ? "Recursos relacionados" : "Related resources"}
        </h2>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          {isEs
            ? "Continúa con una guía del mismo sistema, no con una recomendación genérica."
            : "Continue with a guide from the same operating system, not a generic recommendation."}
        </p>
      </Reveal>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {items.map((item, index) => (
          <Reveal key={item.id ?? item.slug} delay={index * 45}>
            <ResourceCard
              resource={item}
              locale={locale}
              updated={item.reviewed_at || item.updated_at ? formatUpdated((item.reviewed_at ?? item.updated_at) as string, locale) : ""}
              readLabel={isEs ? "Leer" : "Read"}
            />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
